import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { FilterPagination, ResultsInvoice } from '../../files-clients/interface/company-client.interface';
import { faCircleCheck, faCircleMinus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-table-sell-invoces',
  templateUrl: './table-sell-invoces.component.html',
  styleUrls: ['./table-sell-invoces.component.scss']
})
export class TableSellInvocesComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @Output() pages: EventEmitter<any> = new EventEmitter();
  public icons = {faCircleMinus, faCircleCheck, faCircleXmark};
  public dataSource!: MatTableDataSource<ResultsInvoice>;
  public booleanVentas = false;
  public booleanCargandoSellInvoces = true;
  private _sellInvoices: PageResult<ResultsInvoice>;
  @Input()
  set sellInvoices(value: PageResult<ResultsInvoice>) {
    this._sellInvoices = value;
    if (value && value.results) {
      this.setDataSource(value);
      this.booleanCargandoSellInvoces = false;
    }
    if(value && value.totalRows==0) {
      this.booleanVentas=true;
    }
    else {this.booleanVentas=false}
  }
  get sellInvoices(): PageResult<ResultsInvoice> {
    return this._sellInvoices;
  }

  public displayedColumns: string[] = [
    'clientName',
    'clientRut',
    'totalAmount',
    'numberInvoice',
    'fechaDocto',
    'isCedible'
  ];

  ngOnInit() {
    this.setDataSource(this.sellInvoices);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['sellInvoices'] && changes['sellInvoices'].currentValue !== undefined) {
      this.setDataSource(this.sellInvoices);
    }
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe((e) => {
      const pages: FilterPagination = {
        pageSize: e.pageSize,
        page: e.pageIndex + 1,
      };
      this.pages.emit(pages);
    });
  }


  private setDataSource(dataSource: any) {
    const { results, totalRows, pageSize, currentPage } = dataSource || {};
    this.dataSource = new MatTableDataSource<ResultsInvoice>(results);
    this.paginator.pageIndex = currentPage -1;
    this.paginator.length = totalRows;
    this.paginator.pageSize = pageSize;
  }

}
